import styled from 'styled-components';


export const LineImageWidgetContainer = styled.div`
    flex-grow: 1;
    text-align: center;
    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }
`;